/*
  CLAIRENCE : bouton "Commander maintenant" de la fiche produit.
  1. Au clic : vide le panier (/cart/clear.js), ajoute la variante choisie (/cart/add.js), puis ouvre le paiement (/checkout).
     L'ajout passe par /cart/add.js : l'événement "ajout au panier" reste donc compté dans Shopify et Google Ads.
  2. Si une étape échoue, on retombe sur le comportement normal : le formulaire est envoyé (ajout au panier classique).
  3. Le bouton suit l'état du bouton "Ajouter au panier" (désactivé si la variante est épuisée).
  4. Table basse offerte (Black Friday) : si la case de assets/clairence-bundle.js est cochée, la table est ajoutée juste après le canapé.
     Si cet ajout échoue, on ouvre quand même le paiement avec le canapé seul.
  La barre collante (snippets/product-sticky-atc.liquid) clique ce même bouton.
*/
(function () {
  var btn = document.getElementById('ProductBuyNow');
  var form = document.getElementById('ProductForm') || document.querySelector('form.product-form--main');
  if (!btn || !form) return;
  var add = form.querySelector('.product-form__add');
  var busy = false;

  function variantId() {
    var i = form.querySelector('[name="id"]');
    return i ? i.value : '';
  }

  function reset() {
    busy = false;
    btn.classList.remove('is-loading');
    btn.removeAttribute('aria-busy');
    btn.textContent = btn.getAttribute('data-label') || 'Commander maintenant';
  }

  /* Repli : envoi normal du formulaire (ajout au panier classique, puis page panier). */
  function fallback() {
    reset();
    try { form.submit(); } catch (e) { window.location.href = '/cart'; }
  }

  function buyNow() {
    if (busy || btn.disabled) return;
    var id = variantId();
    if (!id) return fallback();
    busy = true;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = 'Redirection vers le paiement…';

    var clearUrl = btn.getAttribute('data-clear-url') || '/cart/clear.js';
    var addUrl = btn.getAttribute('data-add-url') || '/cart/add.js';
    var checkoutUrl = btn.getAttribute('data-checkout-url') || '/checkout';

    fetch(clearUrl, { method: 'POST', headers: { Accept: 'application/json' } })
      .catch(function () {})
      .then(function () {
        var fd = new FormData();
        fd.append('id', id);
        fd.append('quantity', '1');
        [].forEach.call(form.querySelectorAll('[name^="properties["]'), function (p) {
          if (p.value) fd.append(p.name, p.value);
        });
        return fetch(addUrl, { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
      })
      .then(function (r) {
        if (!r.ok) throw new Error('add');
        return r.json();
      })
      .then(function () {
        /* Table basse offerte : ajoutee apres le canape, sans bloquer le paiement si elle echoue. */
        if (window.ClGift && window.ClGift.wanted()) {
          return fetch(addUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [window.ClGift.item()] })
          }).catch(function () {});
        }
      })
      .then(function () { window.location.href = checkoutUrl; })
      .catch(fallback);
  }

  btn.addEventListener('click', buyNow);

  /* Suit l'état du bouton "Ajouter au panier" */
  function sync() { if (add) btn.disabled = add.disabled; }
  if (add) {
    sync();
    if (window.MutationObserver) {
      new MutationObserver(sync).observe(add, { attributes: true, attributeFilter: ['disabled'] });
    }
  }

  /* Retour arrière du navigateur depuis le paiement : on remet le bouton à l'état normal. */
  window.addEventListener('pageshow', function (e) { if (e.persisted) reset(); });
})();